import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { AutoparkTransportFormView } from './transport-form-view';
import {
	getIsTransportTypesListLoadingSelector,
	getTransportTypesListOptionsSelector,
	getAutoparkTransportTariffTypesListSelector,
	getIsAutoparkTransportTariffTypesListLoadingSelector,
	getAddressesListOptionsSelector,
	getIsAddressesListLoadingSelector,
	getFormInitialValuesSelector,
} from '../../selectors';
import { AUTOPARK_TRANSPORT_FORM_NAME } from '../../constants';
import { validate } from '../../utils';

const AutoparkTransportFormWrapper = ({
	isTransportTypesListLoading,
	transportTypesOptionsList,
	autoparkTransportTariffTypesList,
	isAutoparkTransportTariffTypesListLoading,
	addressesListOptions,
	isAddressesListLoading,
}) => {
	return (
		<AutoparkTransportFormView
			isTransportTypesListLoading={isTransportTypesListLoading}
			transportTypesOptionsList={transportTypesOptionsList}
			autoparkTransportTariffTypesList={autoparkTransportTariffTypesList}
			isAutoparkTransportTariffTypesListLoading={isAutoparkTransportTariffTypesListLoading}
			addressesListOptions={addressesListOptions}
			isAddressesListLoading={isAddressesListLoading}
		/>
	);
};

const withForm = reduxForm({
	form: AUTOPARK_TRANSPORT_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(AutoparkTransportFormWrapper);

const mapStateToProps = createStructuredSelector({
	initialValues: getFormInitialValuesSelector(),
	isTransportTypesListLoading: getIsTransportTypesListLoadingSelector(),
	transportTypesOptionsList: getTransportTypesListOptionsSelector(),
	autoparkTransportTariffTypesList: getAutoparkTransportTariffTypesListSelector(),
	isAutoparkTransportTariffTypesListLoading: getIsAutoparkTransportTariffTypesListLoadingSelector(),
	addressesListOptions: getAddressesListOptionsSelector(),
	isAddressesListLoading: getIsAddressesListLoadingSelector(),
});

AutoparkTransportFormWrapper.propTypes = {
	initialValues: PropTypes.object.isRequired,
	isTransportTypesListLoading: PropTypes.bool.isRequired,
	transportTypesOptionsList: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	autoparkTransportTariffTypesList: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			name: PropTypes.string.isRequired,
		}),
	).isRequired,
	isAutoparkTransportTariffTypesListLoading: PropTypes.bool.isRequired,
	addressesListOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isAddressesListLoading: PropTypes.bool.isRequired,
};

const AutoparkTransportForm = connect(mapStateToProps)(withForm);

export { AutoparkTransportForm };
